
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import { map } from 'lodash';

import { getRefinancingManagementTypes } from "../../../redux/actions/managementActions";

const CaseManagementModal = (props) => {
  const { modal, toggle, handleSubmit, handleChange, managementData, managementCreated, getRefinancingManagementTypes, managementCaseTypes } = props;

  useEffect(() => { getRefinancingManagementTypes() }, [getRefinancingManagementTypes]);

  return (
    <Modal isOpen={modal} toggle={toggle} className='crm-modal-gestion-container crm-modal-new-gestion'>
      <ModalHeader toggle={toggle}>
        Nueva Gestión
        <div className="af-gold-line" />
      </ModalHeader>
      <ModalBody>
        <form className='crm-manage-case-form' id='crm-manage-case' onSubmit={handleSubmit}>
          <div className="crm-modal-form-group" >
            <div className="crm-modal-input-group">
              <label htmlFor='managementType'>*Tipo de Gestión</label>
              <Input
                className='crm-modal-input-text'
                id='managementType'
                name='managementType'
                type='select'
                onChange={handleChange}
                value={managementData.managementType}
                disabled={managementCaseTypes.loading || managementCreated.loading}
                required
              >
                <option key='select' value=''>
                  Seleccione
                </option>
                {map(managementCaseTypes.entry, (e) => (
                  <option key={e._id} value={e._id}>
                    {e.name}
                  </option>
                ))}
              </Input>
            </div>
          </div>
          <div className="crm-modal-form-group-textarea">
            <div className="crm-modal-input-group">
              <label htmlFor='comment'>Descripción</label>
              <Input
                className='crm-modal-input-textarea'
                id='comment'
                name='comment'
                type='textarea'
                onChange={handleChange}
                value={managementData.comment}
                disabled={managementCreated.loading}
                maxLength='300'
                required
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button className='crm-modal-btn crm-modal-cancel-btn' onClick={toggle}>
          Cancelar
        </button>
        <button
          className='crm-modal-btn crm-modal-accept-btn'
          form='crm-manage-case'
          type='submit'
          disabled={!managementData.managementType || !managementData.comment}
        >
          {managementCreated.loading ? <Spinner size="sm" /> : 'Crear Gestión'}
        </button>
      </ModalFooter>
    </Modal>
  );
}

CaseManagementModal.propTypes = {
  modal: PropTypes.bool,
  toggle: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  getRefinancingManagementTypes: PropTypes.func,
  managementCaseTypes: PropTypes.shape({
    loading: PropTypes.bool,
    entry: PropTypes.array,
  }),
  managementCreated: PropTypes.shape({
    loading: PropTypes.bool
  }),
  managementData: PropTypes.shape({
    managementType: PropTypes.string,
    comment: PropTypes.string
  })
};

const mapStateToProps = ({ management }) => ({
  managementCaseTypes: management.managementCaseTypes,
});

const mapDispatchToProps = { getRefinancingManagementTypes };

export default connect(mapStateToProps, mapDispatchToProps)(CaseManagementModal);